import { gql } from "@apollo/client";

export const GET_CUSTOM_TIP_MENU = gql`
  query getBroadcasterCustomTipMenu {
    getBroadcasterCustomTipMenu {
      id
      broadcaster
      menuItems {
        name
        description
        cost
        friendlyName
        type
        command
        title
        footer
        image
        tipNote
        color
        isActive
        isPrivate
        isSubscribable
        subscriptionWeeklyPrice
        subscriptionMonthlyPrice
        tags
      }
    }
  }
`;

export const UPDATE_CUSTOM_TIP_MENU_ITEM = gql`
  mutation updateCustomTipMenuItem(
    $itemName: String!
    $input: UpdateCustomTipMenuItemInput!
  ) {
    updateCustomTipMenuItem(itemName: $itemName, input: $input) {
      id
      broadcaster
      menuItems {
        name
        description
        cost
        friendlyName
        type
        command
        title
        footer
        image
        tipNote
        color
        isActive
        isPrivate
        isSubscribable
        subscriptionWeeklyPrice
        subscriptionMonthlyPrice
        tags
      }
    }
  }
`;

export const SANDBOX_DEPLOY_MENU = gql`
  mutation sandboxDeployMenu(
    $sourceBroadcaster: String!
    $targetBroadcaster: String!
  ) {
    sandboxDeployMenu(
      sourceBroadcaster: $sourceBroadcaster
      targetBroadcaster: $targetBroadcaster
    ) {
      id
      broadcaster
      menuItems {
        name
        description
        cost
        friendlyName
        type
        command
        title
        footer
        image
        tipNote
        color
        isActive
        isPrivate
        isSubscribable
        subscriptionWeeklyPrice
        subscriptionMonthlyPrice
        tags
      }
    }
  }
`;

export const CREATE_CUSTOM_TIP_MENU_ITEM = gql`
  mutation createCustomTipMenuItem($input: CreateCustomTipMenuItemInput!) {
    createCustomTipMenuItem(input: $input) {
      id
      broadcaster
      menuItems {
        name
        description
        cost
        friendlyName
        type
        command
        title
        footer
        image
        tipNote
        color
        isActive
        isPrivate
        tags
      }
    }
  }
`;

export const PREVIEW_CUSTOM_TIP_MENU_ITEM = gql`
  mutation PreviewCustomTipMenuItem($input: PreviewCustomTipMenuItemInput!) {
    previewCustomTipMenuItem(input: $input)
  }
`;
